export let TagFormValues = /*#__PURE__*/function (TagFormValues) {
  TagFormValues["TAG_GROUPS"] = "tagGroups";
  return TagFormValues;
}({});